import { createSelector, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { PaginationModel } from "../../OrganizationManager/model/organization";
import { ConfirmDialog, EnumData } from "../model/Enum";
import { deleteEnum, fetchEnumsByType, updateEnum } from "./asyncThunks";

export const enumType = {
    OrganizationType: "OrganizationType",
    ContactGroup: "ContactGroup",
    BusinessCategory: "BusinessCategory",
};
export const enumListTitle = {
    OrganizationType: "Organization Types",
    ContactGroup: "Customer Groups",
    BusinessCategory: "Business Categories",
};
export const initialEnumState = {
    title: "",
    data: [] as EnumData[],
    pagination: {
        startRow: 0,
        rowsPerPage: 10,
        rowsPerPageOptions: [10, 20, 50, 100],
        totalRowCount: 0,
    } as PaginationModel,
    confirmDialog: {
        open: false,
        title: "Deleting",
        message: "Are you sure to delete?",
    } as ConfirmDialog,
};
export const enumManagerSlice = createSlice({
    name: "enumManager",
    initialState: initialEnumState,
    reducers: {
        onChangeEnumPage: (state, action): void => {
            state.pagination.startRow = action.payload;
        },
        onChangeEnumRowPerPage: (state, action): void => {
            state.pagination.rowsPerPage = action.payload;
        },
        onChangeConfirmDialog: (state, action): void => {
            state.confirmDialog = action.payload;
        },
    },
    extraReducers: {
        [`${fetchEnumsByType.fulfilled}`]: (state, action): void => {
            state.data = action.payload.enums;
            state.pagination.startRow = 0;
            state.pagination.totalRowCount = state.data.length;
        },
        [`${deleteEnum.fulfilled}`]: (state, action): void => {
            state.data = action.payload;
            state.pagination.startRow = 0;
            state.pagination.totalRowCount = state.data.length;
        },
        [`${updateEnum.fulfilled}`]: (state, action): void => {
            state.data = action.payload;
            state.pagination.startRow = 0;
            state.pagination.totalRowCount = state.data.length;
        },
    },
});

// Actions
export const { onChangeEnumRowPerPage, onChangeEnumPage, onChangeConfirmDialog } = enumManagerSlice.actions;

// Selectors
export const enumsSelector = createSelector(
    (state: RootState): EnumData[] => state.enumManager.data,
    (customerGroups: EnumData[]): EnumData[] => customerGroups
);

export const paginationSelector = createSelector(
    (state: RootState): PaginationModel => state.enumManager.pagination,
    (pagination: PaginationModel): PaginationModel => pagination
);

export const confirmDialogSelector = createSelector(
    (state: RootState): ConfirmDialog => state.enumManager.confirmDialog,
    (confirmDialog: ConfirmDialog): ConfirmDialog => confirmDialog
);
